import styled from "styled-components";
import { Avatar, Button, Divider, Flex, Layout, Typography } from "antd";
import { COLORS } from "../../../utils/colors";

const { Header } = Layout;
const { Title, Text } = Typography;

export const StyledHeader = styled(Header)`
  && {
    background: transparent;
    padding: 18px 28px;
    height: auto;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  @media (max-width: 991px) {
    && {
      padding: 14px 16px;
      background: ${COLORS.surface};
      border-bottom: 1px solid ${COLORS.border};
    }
  }
`;

export const HeaderLeft = styled(Flex)``;

export const HeaderLeftGroup = styled(Flex)`
  && {
    min-width: 0;
  }
`;

export const HeaderMenuButton = styled(Button)`
  && {
    display: none;
    width: 38px;
    height: 38px;
    min-width: 38px;
    padding: 0;
    align-items: center;
    justify-content: center;
    border: 1px solid ${COLORS.border};
    border-radius: 9px;
    background: ${COLORS.surface};
    color: ${COLORS.textBody};
    box-shadow: none;
  }

  && .anticon {
    font-size: 17px;
  }

  &&:hover,
  &&:focus {
    background: ${COLORS.surface} !important;
    color: ${COLORS.textBody} !important;
    border-color: ${COLORS.border} !important;
  }

  @media (max-width: 991px) {
    && {
      display: inline-flex;
    }
  }
`;

export const HeaderTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 18px !important;
    font-weight: 700 !important;
    color: ${COLORS.textBody} !important;
    margin: 0 !important;
    line-height: 24px !important;
  }

  @media (max-width: 991px) {
    && {
      font-size: 16px !important;
    }
  }
`;

export const HeaderBreadcrumb = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    color: ${COLORS.textMuted};
  }
`;

export const HeaderRight = styled(Flex)``;

export const UserBlock = styled(Flex)`
  && {
    cursor: pointer;
    user-select: none;
  }
`;

export const ProfileMenu = styled.div`
  width: 248px;
  background: ${COLORS.surface};
  border: 1px solid ${COLORS.border};
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.12);
  padding: 14px;
  font-family: "Roboto", sans-serif;
`;

export const ProfileMenuTitle = styled(Text)`
  && {
    display: block;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: ${COLORS.textBody};
    margin-bottom: 12px;
  }
`;

export const ProfileMenuUser = styled(Flex)`
  && {
    min-width: 0;
  }
`;

export const ProfileMenuAvatar = styled(Avatar)`
  && {
    background: #d9e2ec;
    color: ${COLORS.textBody};
    flex-shrink: 0;
  }
`;

export const ProfileMenuUserInfo = styled(Flex)`
  && {
    min-width: 0;
    line-height: 1.2;
  }
`;

export const ProfileMenuName = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: ${COLORS.textBody};
  }
`;

export const ProfileMenuEmail = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    color: ${COLORS.textMuted};
    word-break: break-word;
  }
`;

export const ProfileMenuDivider = styled(Divider)`
  && {
    margin: 12px 0;
    border-color: ${COLORS.borderSoft};
  }
`;

export const ProfileMenuItem = styled(Button)`
  && {
    width: 100%;
    height: 40px;
    padding: 0 10px;
    justify-content: flex-start;
    gap: 12px;
    border: none;
    background: transparent;
    box-shadow: none;
    border-radius: 9px;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: ${COLORS.textBody};
  }

  && .anticon {
    font-size: 16px;
    color: ${COLORS.textMuted};
  }

  &&:hover,
  &&:focus,
  &&:focus-visible,
  &&:active {
    background: transparent !important;
    color: ${COLORS.textBody} !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
`;

export const UserAvatar = styled(Avatar)`
  && {
    background: #d9e2ec;
    color: ${COLORS.textBody};
  }
`;

export const UserInfo = styled(Flex)`
  && {
    line-height: 1.2;
  }

  @media (max-width: 991px) {
    && {
      display: none;
    }
  }
`;

export const UserName = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: ${COLORS.textBody};
  }
`;

export const UserRole = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: ${COLORS.textSubtle};
    letter-spacing: 0.5px;
  }
`;
